const state = {
  emailHistoryListCurrentPage: 1,
  emailHistoryPageListStore: {},
  emailHistoryListLastId: ''
}

const getters = {}

const actions = {
  setEmailHistoryListCurrentPage (context, payLoad) {
    context.commit('setEmailHistoryListCurrentPage', payLoad)
  },
  setEmailHistoryListLastId (context, payLoad) {
    context.commit('setEmailHistoryListLastId', payLoad)
  },
  setEmailHistoryPageListStore (context, payLoad) {
    context.commit('setEmailHistoryPageListStore', payLoad)
  }
}

const mutations = {
  setEmailHistoryListCurrentPage (state, payLoad) {
    state.emailHistoryListCurrentPage = payLoad
  },
  setEmailHistoryPageListStore (state, payLoad) {
    state.emailHistoryPageListStore = payLoad
  },
  setEmailHistoryListLastId (state, payLoad) {
    state.emailHistoryListLastId = payLoad
  }
}

export default {
  name: 'emailHistory',
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
